var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-collapse',{attrs:{"id":"alcor-collapse"}},[_c('el-collapse-item',[_c('template',{slot:"title"},[_vm._t("title")],2),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }